<template>
  <ModalDialog
    ref="dialog"
    title="Edit Contact"
    :submitting="submitting"
    submitTitle="Update"
    icon="fa-id-card-alt"
    :scrollable="true"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="contactForm" :labelColumnSize="3">
      <FormRow label="Name"><FormInputText label="Name" placeholder="Name" v-model="contact.name" field="name" /></FormRow>
      <FormRow label="Details">
          <FormCheckbox label="Customer" v-model="contact.isCustomer" field="isCustomer" />&nbsp;&nbsp;&nbsp;
          <FormCheckbox label="Supplier" v-model="contact.isSupplier" field="isSupplier" />
      </FormRow>
      <FormRow v-if="hasMyobIntegration && contact.isCustomer && contact.isSupplier">
        <FormPanel title="MYOB Warning" panelClass="panel-warning">
          This contact is marked as both a customer and supplier, which is not supported with the MYOB integration. Please select either customer or supplier.<br />
          If both are required, you will need to create two separate contacts, one for the customer details and one for the supplier details.
        </FormPanel>                  
      </FormRow>
      
      <FormRow label="Phone"><FormInputText placeholder="Phone" v-model="contact.phone" field="phone" /></FormRow>
      <FormRow label="Fax"><FormInputText placeholder="Fax" v-model="contact.fax" field="fax" /></FormRow>
      <FormRow label="Website"><FormInputText placeholder="Website" v-model="contact.website" field="website" /></FormRow>
      <FormRow label="Notes"><FormInputTextArea placeholder="Notes" v-model="contact.note" field="note" /></FormRow>

      <FormHorizontalRule />

      <FormRow label="Account Manager" helpTip="The user who manages this contact's account">
        <FormSelect v-model="contact.managerUserId" field="managerUserId" :loading="userListLoading" :options="userList" />
      </FormRow>
      <FormRow label="Default Location" helpTip="The default location for this contact, used as the default location for orders and purchase orders made with this contact">
        <AccountLocationSelect v-model="contact.accountLocationId" field="accountLocationId" />
      </FormRow>
      <FormRow label="Default Tax Rate">
        <TaxRateSelect v-model="contact.defaultTaxRateId" field="defaultTaxRateId" />
      </FormRow>

      <FormRow label="Labels"><FormLabelTag popupName="Contact Labels" v-model="contact.labelList" labelType="contact" field="labelList" /></FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import SalesRateSelect from '@/modules/pricing/components/salesRateSelect'
import AccountLocationSelect from '@/modules/admin/components/accountLocationSelect'
import TaxRateSelect from '@/modules/admin/components/taxRateSelect'

export default {
  name: "ContactEditDialog",
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
    SalesRateSelect,
    AccountLocationSelect,
    TaxRateSelect
  },
  props: {
    contactId: Number,
    isCreateMode: Boolean
  },
  data() {
    return {
      contact: {
        isCustomer: false,
        isSupplier: false
      },
      contactForm: {},
      submitting: false,
      deliveryPriceOptions: [
        { value: 'fixed', name: 'Fixed' },
        { value: 'percent', name: 'Percentage' }
      ],
      userListLoading: true,
      userList: []
    }
  },
  mounted() {
    // Get User list
    // FUTURE: Somehow send a promise to the select component. It can handle loading state based on promise
    this.userListLoading = true
    this.$apiService.userService.getUserList()
    .then(list => {
      this.userList = _.concat(
        [{ value: null, name: 'None' }],
        list.data.map(userInfo => {
          return {
            value: userInfo.id,
            name: userInfo.name
          }
        })
      )
      this.userListLoading = false
    })
  },
  computed: {
  },
  methods: {
    show(contact) {
      // Reset form
      this.contact = {
        labelList: []
      }
      this.contactForm = {}
      this.submitting = false

      if(contact != null) {
        this.contact = _.cloneDeep(contact)
      }

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var contactData = _.cloneDeep(this.$data.contact)
      var updateData = _.pick(contactData, [
        'name', 'isCustomer', 'isSupplier', 'phone', 'fax', 'website', 'note', 'managerUserId', 'accountLocationId', 'labelList', 'defaultTaxRateId'
      ])
      updateData.labelList = updateData.labelList.map(label => label.id)

      this.$apiService.contactService.updateContact(this.contactId, updateData)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.contactForm = this.processFormResponse(err)
        })
    }
  }
}
</script>